var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKPass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 39,
    viewBox: "0 0 109 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5662_5385)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9234 15.4617C30.9234 6.92857 23.9948 0 15.4617 0C6.92857 0 0 6.92857 0 15.4617C0 23.9948 6.92857 30.9234 15.4617 30.9234H30.9234V20.5236H27.7775C26.8921 20.5236 26.1743 19.8061 26.1743 18.9211C26.1743 18.036 26.8921 17.3185 27.7775 17.3185H30.9234V15.4617Z",
    fill: "#583BE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5376 7.83203H34.1211V17.3178H37.1798C38.0653 17.3178 38.783 18.0353 38.783 18.9204C38.783 19.8054 38.0653 20.5229 37.1798 20.5229H34.1211V23.2937C34.1211 31.8268 41.0497 38.7554 49.5828 38.7554H93.5376C102.071 38.7554 108.999 31.8268 108.999 23.2937C108.999 14.7606 102.071 7.83203 93.5376 7.83203Z",
    fill: "#383649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8955 17.1544L12.8447 19.5192V22.8993H9.48193V7.84375H12.8447V14.938L18.8674 7.84375H22.9877L17.0758 14.6601L23.3017 22.8993H19.1079L14.8955 17.1544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3887 15.6777H51.1709C55.0868 15.6777 57.3781 17.8581 57.3781 21.1834C57.3781 24.5088 55.0868 26.7252 51.1709 26.7252H48.7514V30.7333H45.3887V15.6777ZM51.0226 23.7513C52.8891 23.7513 54.0153 22.8641 54.0153 21.1834C54.0153 19.5027 52.8891 18.653 51.0226 18.653H48.7501V23.7513H51.0226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0201 28.027H61.1817L60.1289 30.9462H56.6553L62.4937 15.8906H65.9847L71.8217 30.9462H68.0715L67.0187 28.027H67.0201ZM65.986 25.1078L64.1022 19.8613L62.2184 25.1078H65.9873H65.986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7929 20.2217H81.3193C81.1162 18.9098 80.1369 18.1162 78.5297 18.1162C76.9225 18.1162 76.0915 18.7441 76.0915 19.6499C76.0915 20.7762 77.2552 21.165 80.193 21.7742C83.6667 22.4943 84.849 24.2124 84.849 26.4663C84.849 29.348 82.1329 31.1036 78.7715 31.1036C75.0587 31.1036 72.3426 29.0902 72.1943 25.8757H75.6493C75.8336 27.3173 77.0908 28.2779 79.012 28.2779C80.3787 28.2779 81.3955 27.5939 81.3955 26.6159C81.3955 25.4148 80.3788 24.9352 77.7 24.4355C74.4308 23.8263 72.6566 22.4769 72.6566 19.6513C72.6566 16.8256 75.354 15.3105 78.7528 15.3105C82.1516 15.3105 84.6273 17.3613 84.7943 20.2244L84.7929 20.2217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7236 20.2217H95.25C95.0469 18.9098 94.0676 18.1162 92.4604 18.1162C90.8531 18.1162 90.0221 18.7441 90.0221 19.6499C90.0221 20.7762 91.1858 21.165 94.1237 21.7742C97.5973 22.4943 98.7797 24.2124 98.7797 26.4663C98.7797 29.348 96.0636 31.1036 92.7022 31.1036C88.9894 31.1036 86.2733 29.0902 86.125 25.8757H89.5799C89.7643 27.3173 91.0215 28.2779 92.9427 28.2779C94.3094 28.2779 95.3261 27.5939 95.3261 26.6159C95.3261 25.4148 94.3094 24.9352 91.6307 24.4355C88.3615 23.8263 86.5873 22.4769 86.5873 19.6513C86.5873 16.8256 89.2847 15.3105 92.6835 15.3105C96.0823 15.3105 98.5579 17.3613 98.7249 20.2244L98.7236 20.2217Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5662_5385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 39,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKPass);
export default __webpack_public_path__ + "static/media/K-PASS.39da34bdd3f89bd43790770336b9be13.svg";
export { ForwardRef as ReactComponent };